<template>
  <div class="wrap" v-if="isInit">
    <div class="local">
      <a href="/index.jsp">首页</a>&nbsp;>&nbsp;
      <a @click="$pushByName('visaProduct')" href="javascript:void(0)">签证</a>
      <span v-show="param.relativeCity !== ''">&nbsp;>&nbsp;{{param.relativeCity}}</span>
    </div>
    <div class="visa_route_line">
      <div class="visa_route_line_img">
        <img-lazy :default_src="visa_img" :src="route.img_url"/>
        <div class="download" v-if="url">
          <a :href="url" id="qr_img" target="_blank">
            <p>下载所需资料说明</p>
          </a>
        </div>
        <div
          :class="[{'reserve':!$util.isEmptyObject(route_plan)},{'not-reserve':$util.isEmptyObject(route_plan)}]"
          v-if="$sessionStorageUtil.get('web_type')==2"
        >
          <span @click="reserve()" style="cursor: pointer;">立即预定</span>
        </div>
      </div>
      <div class="visa_route_line_right">
        <div class="visa_route_right_title">
          <p>{{route.route_name}}</p>
          <em>{{route_speciality.interview}}面试</em>
        </div>
        <div class="visa_route_prices">
          <span class="visa_route_price">价格：</span>
          <br>
          <span class="visa_route_person">成人</span>
          <span>
            <em>
              <i>￥</i>
              {{route.reference_price}}
            </em>
          </span>
        </div>
        <div class="visa_route_right_line">
          <p>
            <em>办理周期：</em>
            使领馆收齐资料后的 {{route_speciality.process_cycle}} 个工作日
          </p>
          <p>
            <em>办理要求 :</em>
            <span
              v-html="$util.strToH5Str(route_plan_speciality.handling_requirement)"
              v-if="route_plan"
            ></span>
          </p>
          <p>
            <em>面试：</em>
            {{route_speciality.interview}}(领馆保留面试权利)
          </p>
          <p>
            <em>有效期：</em>
            {{route_speciality.date_of_expiry}}
            {{route_speciality.date_of_expiry_unit}}
            <span
              v-if="route_speciality.date_of_expiry_remark != ''"
            >({{route_speciality.date_of_expiry_remark}})</span>
          </p>
          <p>
            <em>可停留天数：</em>
            {{route_speciality.duration_of_stay}}{{route_speciality.duration_of_stay_unit}}
          </p>
          <p>
            <em>入境次数：</em>
            {{route_speciality.entries}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </p>
          <div class="more_reserve">
            <a
              @click="$popupCenter('visaInterviewDate',{route_id:route_id,
          relative_city:param.relativeCity})"
              href="javascript:void(0)"
              v-if="route_speciality.interview ==='需要'"
            >查看可预约时间 >></a>
          </div>
        </div>
      </div>
    </div>

    <div class="datailMiddle" v-show="is_has_plan_sale_right">
      <span style="display:block;height:54px;margin:30px 0px 30px;">
        <div :class="detailMenufix == true ? 'detailMenuFixed' :'detailMenu'" id="datailMiddle">
          <a class="detal" href="#rdata">所需资料</a>
          <span v-show="route_plan_speciality.handling_procedures !=''">|</span>
          <a class="detal" v-show="route_plan_speciality.handling_procedures !=''" href="#process">办理流程</a><span v-show="route_plan_speciality.handling_notice !=''">|</span>
          <a class="detal" v-show="route_plan_speciality.handling_notice !=''" href="#handling">办理须知</a>
          <span v-show="route_plan_speciality.visa_instruction !=''">|</span>
          <a class="detal" v-show="route_plan_speciality.visa_instruction !=''" href="#instruction">签证说明</a>
          <span v-show="route_plan_speciality.announce !=''">|</span>
          <a class="detal" v-show="route_plan_speciality.announce !=''" href="#notice">使馆公告</a>
          <span v-show="problems.length !==0">|</span>
          <a class="detal" v-show="problems.length !==0" href="#problem">常见问题</a>
        </div>
      </span>
      <div>
        <!--行程介绍-->
        <div class="detailCont" id="rdata">
          <div class="detaelTitle">
            <p>
              <i></i>所需资料
            </p>
          </div>
          <div class="detailCont_bottom">
            <div :class="personnelType == true ? 'detailText_left' :'personnelTypeFixed'">
              <div @click="resetData(false,key)" v-for="(value, key, index) in required_date">
                <a
                  :class="is_show['show_'+key] == true ? 'detal' :''"
                  @click="goAnchor('#anchor-'+index)"
                  href="javascript:void(0)"
                  style="height: auto;"
                >{{person_type[key].category}}</a>
              </div>
              <span @click="resetData(false,'','#anchor-0')">收起所有资料说明</span>
            </div>
            <div class="detailText_right" v-if="required_date">
              <div
                :id="'anchor-'+index"
                class="detail_Text"
                style="height: auto;"
                v-for="(value, key, index) in required_date"
              >
                <div class="title_detail">
                  <p @click="is_show['show_' + key] = !is_show['show_' + key]">
                    {{person_type[key].category}}（共需{{required_date[key].length}}项资料）
                    <img
                      :src="is_show['show_' + key] ? downImg : rightImg"
                      alt
                      class="title_detail_img"
                    >
                  </p>
                </div>
                <div class="detail_Text_center" v-show="is_show['show_' + key]">
                  <div v-for="(item,item_index) in required_date[key]">
                    <p>
                      <i></i>
                      *{{item.system_config.key_name}}
                      ({{item.system_config.key_value2}})
                    </p>
                    <p>
                      <span v-html="$util.strToH5Str(item.param_type_map.description)"></span>
                      <br>
                      <a
                        @click="$popupCenter('viewSampleImg',{route_id:route_id,attachment_info_id:attachment.attachment_info_id
                        ,route_plan_id:route_plan_id,source:source})"
                        href="javascript:void(0)"
                        v-for="(attachment,attachment_index) in item.attachment_infos"
                        v-if="$util.isImage(attachment.file_name)"
                      >查看样图</a>
                      <a :href="attachment.down_load_url" v-else>下载附件</a>
                      &nbsp;&nbsp;
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <span class="detailCont_fy"></span>
        <!--办理流程-->
        <div
          class="detailCont"
          v-show="route_plan_speciality.handling_procedures !=''"
        >
          <div class="detaelTitle">
            <p>
              <i id="process"></i>办理流程
            </p>
          </div>
          <div class="detailText">
            <p v-html="$util.strToH5Str(route_plan_speciality.handling_procedures)"></p>
          </div>
        </div>
        <!--办理须知-->
        <div class="detailCont mb20" v-show="route_plan_speciality.handling_notice !=''">
          <div class="detaelTitle">
            <p>
              <i id="handling"></i>办理须知
            </p>
          </div>
          <div class="detailText">
            <p v-html="$util.strToH5Str(route_plan_speciality.handling_notice)"></p>
          </div>
        </div>
        <!--签证说明-->
        <div class="detailCont" v-show="route_plan_speciality.visa_instruction !=''">
          <div class="detaelTitle">
            <p>
              <i id="instruction"></i>签证说明
            </p>
          </div>
          <div class="detailText">
            <p v-html="$util.strToH5Str(route_plan_speciality.visa_instruction)"></p>
          </div>
        </div>
        <!--使馆公告-->
        <div class="detailCont mb20" v-show="route_plan_speciality.announce !=''">
          <div class="detaelTitle">
            <p>
              <i id="notice"></i>使馆公告
            </p>
          </div>
          <div class="detailText">
            <p v-html="$util.strToH5Str(route_plan_speciality.announce)"></p>
          </div>
        </div>
        <!--常见问题-->
        <div class="detailCont mb20" v-show="problems.length !==0">
          <div class="detaelTitle">
            <p>
              <i id="problem"></i>常见问题
            </p>
          </div>
          <div class="detailText">
            <div :key="index" class="visa_commom_problem" v-for="(item,index) in problems">
              <p>
                <i></i>
                {{item.question}}
              </p>
              <div class="visa_commom_answer" v-html="item.reply"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import visa_img from '@/assets/images/html/visit_05.png'
import downImg from '@/assets/images/html/towards_bottom_03.png'
import rightImg from '@/assets/images/html/towards_right_03.png'
export default {
  name: "VisaRouteInfo",
  componentName: "VisaRouteInfo",
  data () {
    return {
      route_id: '',
      route_list: [],
      visa_img: visa_img,
      route_speciality: {},
      route_plan_speciality: {},
      route: {},
      route_plan: {},
      person_type: {},
      required_date: {},
      url: '',
      relative_city: '',
      problems: [],
      param: {},
      numbers: [0, 1, 2, 3, 4],
      is_show: {
        show_5403: false,
        show_5404: false,
        show_5405: false,
        show_5406: false,
        show_5407: false,
      },
      rightImg: rightImg,
      downImg: downImg,
      detailMenufix: true,
      personnelType: true,
      is_has_plan_sale_right: true,
      get_product_route_url: 'route/visa_product_info/',
      get_visa_required_data_url: 'visa/required_date/',
      get_common_problem_url: 'guest_book/problems',
      isInit: false, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
    }
  },
  created () {
    if (this.$util.isPhone()) {
      window.location.href = process.env.BASE_URL + 'm/common2/visaRouteInfo?route_id=' + this.$route.query.route_id
    }
    var loading = this.$loadingIndicator.eleOpen('信息加载中...')
    this.route_id = this.$route.query.route_id
    //获取签证产品信息
    this.$myGet(this.get_product_route_url + this.route_id)
      .then(res => {
        const rcode = res.response.data.rcode
        const route_info = res.response.data.route_plan_info.route.extend_info
        this.url = res.response.data.url
        this.route_speciality = JSON.parse(route_info).speciality
        this.route = res.response.data.route_plan_info.route
        if (this.route_speciality.interview === "0") {
          this.route_speciality.interview = '不需'
        } else if (this.route_speciality.interview === "1") {
          this.route_speciality.interview = '需要'
        }
        if (rcode == 0) {
          //有计划的订单在线咨询时可以显示产品链接
          const route_plan_extend = res.response.data.route_plan_info.route_plan.extend_info
          this.route_plan = res.response.data.route_plan_info.route_plan
          this.route_plan_speciality = JSON.parse(route_plan_extend).speciality
          this.getVisaRequiredData(this.route_plan.route_plan_id, this.route_plan.source)
          this.is_has_plan_sale_right = res.response.data.is_has_plan_sale_right
          //设置产品咨询
          this.setRouteConsult()
        } else if (rcode == 1000) { //没有计划
          this.$msg('[' + res.status + ']' + res.response.data.messages[0].msg);
          this.is_has_plan_sale_right = false
        }
        this.param['relativeCity'] = this.route.relative_city
        this.getCommonProblem(this.param)
        this.listenerScroll()
        loading.close()
        this.isInit = true
      })
      .catch(err => {
        loading.close()
        this.$msg('[' + err.status + ']' + err.message, 'error')
      })
  },
  beforeDestroy () {
    this.removeRouteConsult()
  },
  methods: {
    setRouteConsult () {
      this.$sessionStorageUtil.set('route_consult',
        {          route_id: this.route.route_id, route_plan_id: this.route_plan.route_plan_id,
          source: this.route_plan.source        })
    },
    removeRouteConsult () {
      this.$sessionStorageUtil.remove('route_consult')
    },
    reserve () {
      if (!this.$util.isEmptyObject(this.route_plan)) {
        let push_name = 'orderSubmit'
        if (this.$isLogin(0)) {
          if (this.is_has_plan_sale_right) {
            push_name = 'aOrderSubmit'
            this.$pushByName(push_name, { route_id: this.route.route_id, route_plan_id: this.route_plan.route_plan_id, source: this.route_plan.source })
          } else {
            this.$msg('没有该计划的销售权限')
          }
        } else {
          this.$pushByName(push_name, { route_id: this.route.route_id, route_plan_id: this.route_plan.route_plan_id, source: this.route_plan.source })
        }
      }
    },
    getVisaRequiredData (product_route_id, source) {
      //所需资料
      this.$myGet(this.get_visa_required_data_url + source + '/' + product_route_id)
        .then(res => {
          const rcode = res.response.data.rcode
          if (rcode == 0) {
            this.required_date = res.response.data.system_config_vos_map
            this.person_type = res.response.data.categorys
          } else {
            this.$msg('[' + res.status + ']' + res.response.data.messages[0].msg, 'error')
          }
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message, 'error')
        })
    },
    getCommonProblem () {
      //常见问题
      this.$myGet(this.get_common_problem_url, this.param)
        .then(res => {
          var problemList = res.response.data.guest_books
          if (problemList.length > 0) {
            problemList.forEach(item => {
              this.problems.push(item)
            })
          }
        }).catch(err => {
          this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
        })
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let offsetTop = document.querySelector('.datailMiddle').offsetTop + 360
      if (scrollTop > offsetTop) {
        this.detailMenufix = false
      } else {
        this.detailMenufix = true
      }
    },
    handleLeftScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let offsetTop = document.querySelector('.detailCont').offsetTop + 360
      var offsetbottom = document.querySelector('.detailCont_fy').offsetTop + 360
      if (scrollTop > offsetTop && scrollTop < offsetbottom) {
        this.personnelType = false
      } else {
        this.personnelType = true
      }
    },
    resetData (flag, key, selector) {
      this.is_show.show_5403 = flag
      this.is_show.show_5404 = flag
      this.is_show.show_5405 = flag
      this.is_show.show_5406 = flag
      this.is_show.show_5407 = flag
      if (key !== '') {
        this.is_show['show_' + key] = !this.is_show['show_' + key]
      } else {
        this.goAnchor(selector)
      }
    },
    goAnchor (selector) {
      var anchor = this.$el.querySelector(selector)
      document.documentElement.scrollTop = anchor.offsetParent.offsetTop + 300
    },
    listenerScroll () {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('scroll', this.handleLeftScroll)
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('scroll', this.handleLeftScroll)
  },

}
</script>
<style scoped>
@import '../../assets/css/pages/html/viasproduct.css';
</style>



// WEBPACK FOOTER //
// src/pages/common/visaRouteInfo.vue